// reducer.js
import {
  SET_VALUE_ModeleInvest,
  SET_TYPE_ModeleInvest,
  SET_CURRENT_PAGE_ModeleInvest,
  SET_ORDER_ModeleInvest,
  SET_SORT_FIELD_ModeleInvest,
  SET_ACTIF_ModeleInvest,
  SET_CATEGORIE_ModeleInvest,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "desc",
  sortField: "cree_le",
  categorie: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_ModeleInvest:
      return {
        ...state,
        value: action.payload,
      };
    case SET_CATEGORIE_ModeleInvest:
      return {
        ...state,
        categorie: action.payload,
      };
    case SET_TYPE_ModeleInvest:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_ModeleInvest:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_ModeleInvest:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_ModeleInvest:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_ModeleInvest:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
